import { ILineCreditLimitDrawerInfo } from '.';

export function graphqlToDefaultLineCreditLimitInfo(
  data: any
): ILineCreditLimitDrawerInfo {
  const businessPartnerLine =
    data?.SalesforceManagement?.entities?.businessPartnerLine?.views
      ?.SalesforceManagement_all?.properties;
  return {
    creditLimit: businessPartnerLine?.CreditLimit,
    creditLimitCurrency: businessPartnerLine?.CreditLimitCurrency?.Id,
    gracePeriod: businessPartnerLine?.GracePeriod,
  };
}
